import React from 'react';
import { FormattedMessage } from 'react-intl';
import { AppState } from 'src/AppState';
import { WindshieldPlaceholder } from 'src/easyclaim.app.components/common/ImageRepository';
import { reportError } from 'src/easyclaim.app.libs/reportError';

import { EasyClaimDocumentType } from '../../easyclaim.api.client.typescript/src/index';
import {
	ExampleModalImage,
	SelectImage,
	StyledInfoIcon,
} from '../../easyclaim.app.components/index';
import { Image } from '../../easyclaim.app.services/ImageSelectionService';
import { FourAdditionalPicturesProps, isAnyOfImagesLoading } from '../FourAdditionalPictures';

export function WindshieldControl(props: FourAdditionalPicturesProps) {
	return (
		<>
			<h3 className="four-additional-pictures-windshield-title">
				<FormattedMessage id="fourAdditionalPictures.windshield.title" />
			</h3>
			<p className="four-additional-pictures-windshield-description">
				<FormattedMessage id="fourAdditionalPictures.windshield.description" />
				<StyledInfoIcon
					onClick={() => {
						showWindshieldExampleImage(props).catch(reportError);
					}}
				/>
			</p>
			<div className="four-additional-pictures-detail-container">
				<SelectImage
					componentId="windshieldImage"
					fileType={EasyClaimDocumentType.WindshieldPicture}
					caseId={props.easyClaimCase?.caseId}
					easyClaimService={props.easyClaimService}
					currentImage={props.windshieldImage}
					title="windshieldImage.headline"
					marginBottom="1rem"
					onChange={(image) => {
						const newState = windshieldImageChanged(props, image);

						void props.setAppState(newState);
					}}
					onShowExample={() => {
						showWindshieldExampleImage(props).catch(reportError);
					}}
					showUserFeedbackInfo={true}
					placeholder={<WindshieldPlaceholder />}
					configuration={props.easyClaimCase!._configuration!}
					inputError={props.inputError}
				/>
			</div>
		</>
	);
}

function showWindshieldExampleImage(currentAppState: AppState) {
	const images: ExampleModalImage[] = [
		{ src: `${process.env.PUBLIC_URL}/images/example-windshield.jpg` },
	];

	return currentAppState.showExampleModal(
		images,
		'fourAdditionalPictures.windshield.exampleModalTitle',
		'fourAdditionalPicturesExampleModal.button.close',
		'windshield'
	);
}

function windshieldImageChanged(currentAppState: AppState, image: Image | undefined): AppState {
	// const isImageLoading = ImageSelectionService.isImageLoading(image);
	let images: Image[] = [];

	images = currentAppState.overallDashboardImage
		? images.concat([currentAppState.overallDashboardImage])
		: images;
	images = currentAppState.dashboardImage
		? images.concat([currentAppState.dashboardImage])
		: images;
	images = image ? images.concat([image]) : images;
	images = currentAppState.vinImage ? images.concat([currentAppState.vinImage]) : images;

	const isImageLoading = isAnyOfImagesLoading(images);

	const newState = Object.assign({}, currentAppState, {
		windshieldImage: image,
		isImageLoading: isImageLoading,
	});

	return newState;
}
